import React from 'react';
import { HrnbRow, HrnbCol } from '../../../components/controls/HrnbContainer';
import HrnbCard from '../../../components/controls/HrnbCard';
import HrnbButton from '../../../components/controls/HrnbButton';
import { EditIcon } from '../../../icons';

/**
 * Вкладка "Правила" страницы баттла
 */
const BattleRulesTab = ({
  battleRules,
  battleLimitations,
  regulation,
  isUserOrganizer,
  onEditRegulation,
}) => {
  return (
    <HrnbRow>
      <HrnbCol xs={12}>
        <HrnbCard
          title="Правила и регламент"
          className="battle-detail-card"
          actions={
            isUserOrganizer ? (
              <HrnbButton
                variant="outline-primary"
                size="sm"
                onClick={onEditRegulation}
              >
                <EditIcon style={{ width: 14, height: 14, marginRight: 6 }} />
                Редактировать регламент
              </HrnbButton>
            ) : null
          }
        >
          {battleRules.length > 0 ||
          (regulation &&
            Array.isArray(regulation.rules) &&
            regulation.rules.length > 0) ? (
            <div className="battle-detail-rules-content">
              <h5>Правила баттла</h5>
              <ul>
                {(battleRules.length > 0 ? battleRules : regulation.rules).map(
                  (r, i) => (
                    <li key={i}>
                      <strong>
                        {typeof r === 'string' ? r : r.title || 'Правило'}
                      </strong>
                      {typeof r !== 'string' && r.description && (
                        <p className="text-muted mb-1">{r.description}</p>
                      )}
                    </li>
                  )
                )}
              </ul>
            </div>
          ) : (
            <p className="text-muted">Правила не указаны</p>
          )}

          {battleLimitations.length > 0 ||
          (regulation &&
            Array.isArray(regulation.limitations) &&
            regulation.limitations.length > 0) ? (
            <div className="battle-detail-regulation-content mt-4">
              <h5>Ограничения</h5>
              <ul>
                {(battleLimitations.length > 0
                  ? battleLimitations
                  : regulation.limitations
                ).map((l, i) => (
                  <li key={i}>
                    <strong>
                      {typeof l === 'string' ? l : l.title || 'Ограничение'}
                    </strong>
                    {typeof l !== 'string' && l.description && (
                      <p className="text-muted mb-1">{l.description}</p>
                    )}
                    {typeof l !== 'string' && l.value && (
                      <p className="text-muted mb-1">
                        <small>Значение: {l.value}</small>
                      </p>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}

          {regulation && (
            <div className="battle-detail-regulation-content mt-4">
              <h5>Регламент</h5>
              {regulation.ageLimits && (
                <div className="regulation-item">
                  <strong>Возрастное ограничение:</strong>{' '}
                  {regulation.ageLimits}
                </div>
              )}
              {regulation.formats && (
                <div className="regulation-item">
                  <strong>Форматы:</strong> {regulation.formats}
                </div>
              )}
            </div>
          )}
        </HrnbCard>
      </HrnbCol>
    </HrnbRow>
  );
};

export default BattleRulesTab;
